import { InternalAxiosRequestConfig } from 'axios'
import { resolveAppVersion, source } from '../../../../utils/base_params_utils'

const injectBaseParamsDefault = (config: InternalAxiosRequestConfig) => {
  config.params = {
    ...(config.params ?? {}),
    source: source,
    app_version: resolveAppVersion()
  }

  return config
}

export default injectBaseParamsDefault
